export type ReasoningPhase = 'analyzing' | 'searching' | 'displaying' | null;

const DEFAULT_BLURB_INTERVAL_MS = 6000;

const BLURB_INTERVAL_OVERRIDES: Partial<
    Record<NonNullable<ReasoningPhase>, number>
> = {
    displaying: 10000,
};

export function getBlurbIntervalMs(phase: ReasoningPhase): number {
    return (
        (phase && BLURB_INTERVAL_OVERRIDES[phase]) ?? DEFAULT_BLURB_INTERVAL_MS
    );
}

interface ReasoningPhaseArgs {
    isLoading: boolean;
    analyzedQueries: unknown;
    eventCount: number;
    identityCount: number;
}

export function getReasoningPhase({
    isLoading,
    analyzedQueries,
    eventCount,
    identityCount,
}: ReasoningPhaseArgs): ReasoningPhase {
    if (!isLoading) return null;
    if (eventCount > 0 || identityCount > 0) return 'displaying';
    if (analyzedQueries) return 'searching';
    return 'analyzing';
}
